import { GET_LOGOUT_REQUESTED } from "resources/actionTypes"

export function getLogout(userLogout,navigate){
    const data = {
        userLogout:userLogout,
        navigate:navigate
    }
    return {
        type: GET_LOGOUT_REQUESTED,
        payload: data,
    }
}